export default "__VITE_ASSET__4a8643b1__"